import React from "react";
import {
  createRoutesFromChildren,
  matchRoutes,
  useLocation,
  useNavigationType,
} from "react-router-dom";

import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  tunnel: new URL("monitoring", import.meta.env.VITE_API_URL).toString(),
  // Setting this option to true will send default PII data to Sentry.
  // For example, automatic IP address collection on events
  sendDefaultPii: true,
  integrations: [
    Sentry.reactRouterV6BrowserTracingIntegration({
      useEffect: React.useEffect,
      useLocation,
      useNavigationType,
      createRoutesFromChildren,
      matchRoutes,
    }),
    Sentry.consoleLoggingIntegration({ levels: ["log", "error", "warn"] }),
    Sentry.replayIntegration({
      mask: ["[data-sentry-mask]"],
      maskAllText: false,
    }),
  ],
  _experiments: { enableLogs: true },
  normalizeDepth: 5,
  environment: import.meta.env.MODE,
  enabled: import.meta.env.PROD,
  // Performance Monitoring
  tracesSampleRate: import.meta.env.DEV ? 1.0 : 0.7,
  tracePropagationTargets: ["localhost", import.meta.env.VITE_API_URL],
  // Session Replay
  replaysSessionSampleRate: 0.1, // This sets the sample rate at 10%. You may want to change it to 100% while in development and then sample at a lower rate in production.
  replaysOnErrorSampleRate: 1.0, // If you're not already sampling the entire session, change the sample rate to 100% when sampling sessions where errors occur.
});
